<template>
  <label 
    v-if="showLabel"
    for="cover_photo" 
    class="block text-sm font-medium"
  >
    {{ $t(label) }}
  </label>
  <input :type="type" :name="name" :id="id" v-model="value" class="hidden" />

  <div class="mt-1 mb-2 space-y-2">
    <!--
    <transition-group
      :enter-active-class="
        showDropZone
          ? 'animate__animated animate__slideInTop animate__faster'
          : 'animate__animated animate__slideInBottom animate__faster'
      "
      :leave-active-class="
        showDropZone
          ? 'animate__animated animate__slideOutBottom animate__faster'
          : 'animate__animated animate__slideOutTop animate__faster'
      "
    >
    -->
    <img v-if="image && value" :src="image" alt="" class="rounded-md" style="max-width: 150px" key="img"/>
    <img v-else-if="!value && placeholder" :src="placeholder" alt="" class="rounded-md" style="max-width: 150px" key="placeholderimg"/>
    <div v-else-if="file" class="flex space-x-2 items-center">
      <div class="flex-row items-center justify-center text-center">
        <aw-icon
          icon="document"
          class="h-8 w-8 text-gray-400  flex-grow"
        />
        <div class="text-xs flex-grow text-center">
          {{ file.ext }}
        </div>
      </div>
      <div class="text-sm">
        {{ file.name }}
      </div>
    </div>
    <div
      key="dropzone"
      v-show="showDropZone"
      class="
        flex
        justify-center
        px-6
        py-5
        border-2 border-gray-400
        hover:border-bc-blue
        border-dashed
        rounded-md
        cursor-pointer
        hover:text-bc-blue
        text-gray-400
      "
      v-bc-uploader="{
        name: 'BcInputUpload',
        onFileUploadDone: fileUploadDone,
        onAllFilesUploadDone: allFilesUploadDone,
        maxUploadFiles: 1,
        exts: allowedTypes ? allowedTypes.split(',') : null,
      }"
    >
      <div class="space-x-1 text-center">
        <div class="flex flex-row justify-center items-center mb-2">
          <svg
            class="inline-block h-12 w-12"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
            aria-hidden="true"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="relative cursor-pointe rounded-md font-medium w-auto text-gray-400">
            {{$t('Drag the file here, or click to add a file')}}
          </span>
        </div>
        <p class="text-xs text-gray-400">{{ $t(hint) }}</p>
      </div>
    </div>
    <!--
    </transition-group>
    -->
    <div v-if="showReplaceButton" class="space-x-2">
      <a
        v-if="!showDropZone"
        @click.stop.prevent="toggleDropZone()"
        class="text-xs btn btn-primary-outlined btn-xs select-none"
      >
        <aw-icon icon="switch" class="w-4 h-4 mr-1" /> {{$t('Replace')}}
      </a>
      <a
        v-if="showDropZone"
        @click.stop.prevent="cancel()"
        class="text-xs btn b-gray-400 text-gray-400 btn-xs select-none"
      >
        <aw-icon icon="switch" class="w-4 h-4 mr-1" /> {{$t('Cancel')}}
      </a>
      <a
        v-if="showDropZone && value"
        @click.stop.prevent="removeFile()"
        class="text-xs btn b-red-500 text-red-500 btn-xs select-none"
      >
        <aw-icon icon="switch" class="w-4 h-4 mr-1" /> {{$t('Remove file')}}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    type: String,
    name: String,
    required: Boolean,
    disabled: Boolean,
    id: String,
    preview: {
      type: String,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    modelValue: [String, Number],
    allowedTypes: {
      type: String,
      required: false,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      isDropZoneOpened: false
    };
  },
  methods: {
    toggleDropZone() {
      this.isDropZoneOpened = !this.isDropZoneOpened;
    },
    removeFile() {
      this.value = null
      this.file = null
      this.isDropZoneOpened = false
    },
    cancel() {
      if (this.file) {
        this.value = this.file.id
      }
      this.toggleDropZone()
    },
    fileUploadDone(file) {
      this.file = file
      this.value = file.id
      this.isDropZoneOpened = false
    },
    allFilesUploadDone() {

    }
  },
  computed: {
    hint () {
      return this.$controls[this.id].hint
    },
    label () {
      return this.$controls[this.id].label
    },
    image() {
      if (!this.preview || !this.file) {
        return null
      }

      return this.file?.previews[this.preview]
    },
    showReplaceButton() {
      return this.image || this.placeholder || this.file;
    },
    showDropZone() {
      return this.isDropZoneOpened || (!this.image && !this.placeholder && !this.file);
    },
    value: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    },
    file: {
      get () {
        return this.$controls[this.id].file
      },
      set (val) {
        this.$store.commit('nette/updateControl', {
          controlName: this.id,
          data: val,
          key: 'file',
        })
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>
